<template>
  <div class="cpt-notice-area fixed bottom-0 right-0 w-[352px] flex flex-col p-[16px] pointer-events-none min-h-[105px] z-[2000]">
    <transition-group name="card">
      <NoticeCard 
        v-for="item, index in showQueue"
        :key="item.key" 
        :message="item"
        @destroy="removeCard(index)"
        :ref="`noticeCard${item.key}`"
      ></NoticeCard>
    </transition-group>
  </div>
</template>

<script>
const NoticeCard = () => import('./NoticeCard.vue')
import EventBus from '@/common/EventBus';
import markdownToHtml from '_lib/MarkdownToHtml.js'

import { getMsgDesc } from '_lib/MessageNoticeText'

import { getShowNotification, updateMessageNotified, getChannelLastMsg } from '_api/message';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { deepCopy, getStorage } from '_lib/utils/utils';
import { calcUserName } from '_lib/CalcUserInfo';

import { CHANNEL_TYPES } from '@/common/constants/channel';
import { ROOM_NOTIFY_SETTING_ENUM, DEFAULT_ROOM_AVATAR } from '@/common/constants/room';
import { IM_RECEIVE_TYPE, IM_MSG_TYPE } from '@/common/constants/IM.ts'
import { NEW_OFFICIAL_MESSAGE_ID, NOTIFY_TYPES, OFFICAL_MSG_BASIC, DEFAULT_NOTIFY_TYPES, NOTICE_TYPE_TEXT } from '@/common/constants/message';
import { NOTICE_CARD_TYPE } from '_lib/constants/notice-card';
import { MESSAGE_CONTENT_COMPONENT } from '@/common/constants/IM.ts'
import { MESSAGE_MP3 } from '_lib/constants/global'
import { playAudio } from '_lib/utils/utilsMedia';
import { calcIsGroupAtMe } from '@/common/utils/utilsGroup';
import { messageDataRestructure } from '_lib/IM';
import { GROUP_CHAT_UNIVERSAL_TIP_TYPES } from '@/views/room/IM/MessageList/components/GroupChatUniversalMessage/constants';
import { MESSAGE_COMPONENT_TYPE } from '@/common/constants/message-cpt';

export default {
  components: {
    NoticeCard
  },
  data() {
    return {
      waitQueue: [], // 后台状态等待显示的消息
      showQueue: [],
      pageHidden: false,
      notifyAccess: false,
      windowShow: true,
      hasFullwindow: false,
      disableTransition: false,
      offlineTrayCount: 0,
    };
  },
  created() {
    this.initMessageList()
    if (window.Notification) {
      Notification.requestPermission().then(res=> {
        if(res == 'granted'){
          this.notifyAccess = true
        }
      })
    }
  },
  mounted() {
    // 消息请求通知
    EventBus.$on('SOCKET_UPDATE_MESSAGE_LIST', this.handleNewNotice)
    // IM通知
    EventBus.$on('SOCKET_SEND_MESSAGE', this.handleNewIM)
    EventBus.$on('SOCKET_USER_IM_MESSAGE', this.handleNewIM)
    EventBus.$on('SOCKET_RECEIVE_AT', this.handleAtIM)
    // 活动掉宝通知
    EventBus.$on('SOCKET_BOX_ACTIVITY_DROP', this.handleActivityBoxDrop)
    // 组队大厅持续等待通知
    EventBus.$on('POLLING_TEAM_LIST_UPDATE', this.handleTeamListUpdate),
    // 邀约开始前时间通知
    EventBus.$on('SOCKET_TIME_NOTICE', this.handleTeamInviteDue)
    // 系统消息推送
    EventBus.$on('SOCKET_OFFICIAL_UNREAD_MESSAGES', this.handleOfficialMsg)

    // 组队帖子更新
    EventBus.$on('SOCKET_TEAM_LIST_UPDATE', this.handleTeamPush);

    // 收到第一条房间消息通知
    EventBus.$on('SOCKET_RECEIVED_ROOM_FIRST_MSG', this.handleReceiveRoomFirstMsg);
    EventBus.$on('SOCKET_ROOM_NOTIFY_TYPE_CHANGE', this.handleRoomNotifyTypeChange);
    EventBus.$on('initOfflineTrayMsg', this.handleInitOfflineTray)

    // 监听页面状态变化
    this.pageStatusRegister()
    if (process.env.IS_CLIENT) {
      this.initNvVsyncSettingNotify()
    }
  },
  beforeDestroy() {
    EventBus.$off('SOCKET_UPDATE_MESSAGE_LIST', this.handleNewNotice)
    EventBus.$off('SOCKET_SEND_MESSAGE', this.handleNewIM)
    EventBus.$off('SOCKET_USER_IM_MESSAGE', this.handleNewIM)
    EventBus.$off('SOCKET_RECEIVE_AT', this.handleAtIM)
    EventBus.$off('SOCKET_BOX_ACTIVITY_DROP', this.handleActivityBoxDrop)
    EventBus.$off('POLLING_TEAM_LIST_UPDATE', this.handleTeamListUpdate)
    EventBus.$off('SOCKET_TIME_NOTICE', this.handleTeamInviteDue)
    EventBus.$off('SOCKET_OFFICIAL_UNREAD_MESSAGES', this.handleOfficialMsg)
    EventBus.$off('SOCKET_TEAM_LIST_UPDATE', this.handleTeamPush);
    EventBus.$off('SOCKET_RECEIVED_ROOM_FIRST_MSG', this.handleReceiveRoomFirstMsg);
    EventBus.$off('SOCKET_ROOM_NOTIFY_TYPE_CHANGE', this.handleRoomNotifyTypeChange);
    EventBus.$off('initOfflineTrayMsg', this.handleInitOfflineTray)
  },
  computed: {
    ...mapGetters([
      'user_info', 
      'tip_sound_control', 
      'tip_sound_volume', 
      'cur_private_user', 
      'cur_text_channel_data', 
      'cur_channel_data', 
      'room_list', 
      'all_notify_settings',
      'channelIMId',
      'recent_msg_list',
      'online_state',
      'anchor_mode',
      'user_account_settings',
      'cur_channel_has_screen_share',
      'is_screen_share_browser_fullscreen',
      'is_screen_share_fullscreen',
      'setting_data',
      'all_unread_states',
      'recent_msg_count',
      'is_show_screen_sharing',
      'audio_im_need_scroll_to_bottom',
      'all_chat_group_notify_settings',
      'cur_group_chat',
      'cur_global_team',
    ]),
    preventNotify() {
      return (this.anchor_mode && this.user_account_settings.anchor_mode_close_notify) 
        || this.online_state == 6
    },
    is_screen_share() {
      return this.cur_channel_has_screen_share && (this.is_screen_share_browser_fullscreen || this.is_screen_share_fullscreen)
    },
  },
  methods: {
    initMessageList() {
      getShowNotification().then(res=> {
        if(res.data.status == 'ok') {
          let msgs = res.data.result.msg_list || []
          if (msgs.length > 0) {
            msgs.reverse()
            msgs.forEach(v => {
              v.card_type = 0
              v.key = v.msg_id
              this.addNotice(v)
            })
          }
        }
      })
    },
    // 首次弹出通知后更新状态，下次不再弹出
    updateMessageNotified (msg_id) {
      if (!msg_id) return
      updateMessageNotified({ _notip: 1 }, { msg_id: Number(msg_id) })
    },
    pageStatusRegister() {
      if(process.env.IS_CLIENT) {
        process.env.IS_CLIENT && window.electronAPI.onMainWindowState((_event, value) => {
          if (value === 'minimize' || value === 'hidden') {
            this.windowShow = false
          }
          else if (value === 'restore' || value === 'show') {
            this.windowShow = true
          }
          if (value === 'blur') {
            this.windowFocus = false
          } else if (value === 'focus') {
            this.windowFocus = true
          }
          this.checkWindow()
        })
        process.env.IS_CLIENT && window.electronAPI.onHasFullScreenWindow((_event, value) => {
          this.hasFullwindow = value
          this.checkWindow()
        })
      } else {
        this.addPageStatusListener()
      }
    },
    async initNvVsyncSettingNotify () {
      const setting = await window.electronAPI.getNvVsyncSetting()
      if (setting === 'virtual') {
        const msg = {
          card_type: NOTICE_CARD_TYPE['operate'],
          notify_type: NOTIFY_TYPES['nv_vsync'],
          nickname: '提示',
          iconfont: 'icon-notice',
          msg: '检测到显卡设置开启了垂直同步，可能会导致画面卡顿，建议关闭垂直同步',
          noBreakMsg: true,
          disable_auto_destroy: true,
          key: Date.now(),
        }
        this.addNotice(msg)
        EventBus.$on('setNvVsyncSetting', this.handleHideNvVsyncNotice)
      }
    },
    handleHideNvVsyncNotice() {
      window.electronAPI.setNvVsyncSetting()
      this.$query({
        config: {
          title: '提醒一下',
          desc: `更改垂直同步设置将在重启后生效`,
          confirm: {
            text: '我知道了'
          }
        },
      })
      this.showQueue = this.showQueue.filter(v => v.notify_type !== NOTIFY_TYPES['nv_vsync'])
      EventBus.$off('setNvVsyncSetting', this.handleHideNvVsyncNotice)
    },
    addPageStatusListener() {
      let hidden, visibilityChange;
      if (typeof document.hidden !== "undefined") {
        hidden = "hidden";
        visibilityChange = "visibilitychange";
      } else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
      } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
      }
      let handleVisibilityChange = () => {
        this.pageChange(document[hidden])
      }
      document.addEventListener(visibilityChange, handleVisibilityChange, false);
    },
    async handleNewNotice(data) {
      if (this.preventNotify) return
      let msg = data.data.notify_body
      msg.card_type = 0
      msg.notify_type = data.data.notify_type
      msg.key = data.sequence
      this.addNotice(msg)
      this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
      if (process.env.IS_CLIENT) {
        window.electronAPI.setTrayMessage(this.handleTrayMessage(msg, 'notify'))
      }
      if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
        let mynotification = new Notification(msg.nickname ,{
          body: getMsgDesc(msg),
          icon: msg.avatar
        });
        mynotification.onclick = function() {
          window.focus();
        }
      }
    },
    calcIsAt (msg) {
      return msg.msg_type === IM_MSG_TYPE['AtOrChannel'] && msg.at_users?.find(v => v.user_id == this.user_info.user_id)
    },
    formatNewIMMsg (d, data, isOverlay = false) {
      // type=4为markdown格式，需要转化为html
      if ([IM_MSG_TYPE['markdown'], IM_MSG_TYPE['AtOrChannel']].indexOf(d.msg_type) >= 0) {
        d.msg = d.msg.replace(/!\[\]\((https:\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com\/pic\/\d+\.png)\)/g, '[图片]').replace(/\[custom(.*?)_(.*?)\]/g, '[表情]');
        d.msg = markdownToHtml(d, false, isOverlay)
      }
      let msg = JSON.parse(JSON.stringify(d))
      msg.key = data.sequence
      if (msg.receive_type === IM_RECEIVE_TYPE.private) { // 私聊
        msg.card_type = NOTICE_CARD_TYPE['private_im']
        return msg
      }
      if(d.receive_type === IM_RECEIVE_TYPE.chat_group) {
        // 获取配置
        const getGroupChatCardConfig = () => {
          if(d.msg_type === IM_MSG_TYPE.chatGroupUniversal) {
            const tipType = d.tip_actions.tip_type
            if(tipType === 'apply_join') {
              if(tipType === GROUP_CHAT_UNIVERSAL_TIP_TYPES.apply_join) {
                return {
                  card_type: NOTICE_CARD_TYPE['operate'],
                  avatar: d.chat_group_avatar,
                  avatarType: 'rectangle',
                  title: '你有一条进群申请，待审批',
                }
              }
            }
          } else {
            return {
              card_type: NOTICE_CARD_TYPE['chat_group_im'],
              avatar: d.avatar,
              avatarType: 'rectangle',
              title: d.chat_group_name,
              isAt: this.calcIsAt(msg)
            }
          }
        }
        const cardConfig = getGroupChatCardConfig()
        Object.assign(msg, cardConfig)
        const userNickname = calcUserName(d)
        msg.msg = `${userNickname}：${d.msg}`
        if (this.calcIsAt(msg)) {
          msg.msg = `${userNickname} @了你`
        }
      } else if (d.receive_type === IM_RECEIVE_TYPE.global_team) {
        msg.card_type = NOTICE_CARD_TYPE['global_team_im']
        msg.avatar = d.global_team_info.app_icon
        msg.avatarType = 'rectangle'
        msg.title = `${d.global_team_info.app_name} 全局组队新消息`
        msg.msg = calcUserName(d) + `：${d.msg}`
      } else {
        const room = this.room_list.find(v => v.room_id == msg.room_id)
        msg.card_type = NOTICE_CARD_TYPE['channel_im']
        msg.avatar = room.room_avatar || 'default_room_avatar'
        msg.avatarType = 'rectangle'
        msg.title = calcUserName(msg) + `(${msg.channel_name}，${room.room_name})`
        if (this.calcIsAt(msg)) {
          msg.msg = '@了你'
        }
      }
      return msg
    },
    async handleNewIM(data) {
      if (this.preventNotify) return
      // 深拷贝一次，不然修改.msg会影响MsgCacheHandler里面的SOCKET_SEND_MESSAGE
      data = deepCopy(data)
      let d = data.data
      if (d.updated) return // 编辑消息不通知
      // 自己发送的不通知
      let addition = d.addition || '{}'
      try {
        addition = JSON.parse(addition)
      } catch (e) {
        addition = {}
      }
      // 如果是自己发送的消息且不是强制通知
      if (d.user_id == this.user_info.user_id && !addition.force_toast) {
        return
      }
      // 如果是正在私聊的用户不进行通知
      if (d.receive_type === IM_RECEIVE_TYPE.private && d.user_id == this.cur_private_user.user_id) return
      // 如果是当前群聊的聊天不进行通知
      if (d.receive_type === IM_RECEIVE_TYPE.chat_group && d.chat_group_id == this.cur_group_chat.chat_group_info?.chat_group_id) return
      // 如果是当前全局组队聊天室的聊天不进行通知
      if (d.receive_type === IM_RECEIVE_TYPE.global_team && this.cur_text_channel_data.channel_type === CHANNEL_TYPES.global_team && d.channel_id == this.cur_global_team.team_id) return
      let isCurChannelIm = this.channelIMId == d.channel_id
      let isResourceChannelMsg = d.is_resource_chan
      // 屏幕共享中并且是全屏的话，在屏幕共享中显示，不能直接return
      const isOverlayShow = window.overlayAPI?.overlayShow && this.setting_data.show_msg_from_channel
      let room = this.room_list.find(v => v.room_id == d.room_id);
      if (![IM_RECEIVE_TYPE.private, IM_RECEIVE_TYPE.chat_group, IM_RECEIVE_TYPE.global_team].includes(d.receive_type)) { // 频道消息需要查看通知设置
        // 如果 正在展示的频道或资源频道消息 不进行通知
        if ((isCurChannelIm || isResourceChannelMsg) && !isOverlayShow) {
          return
        }
        let notify_setting = this.$unread.getNotifySetting({
          room_id: d.room_id,
          channel_id: d.channel_id
        })
        if (notify_setting.is_dnds) { // 消息免打扰时直接返回
          return
        }
        if (notify_setting.notify_type === ROOM_NOTIFY_SETTING_ENUM['none']) { // 如果频道通知设置为不通知，不进行处理
          return
        }
        if ((this.cur_channel_data.channel_id == d.channel_id) && isOverlayShow) {
          let msg = this.formatNewIMMsg(d, data, true)
          if (isOverlayShow) {
            window.overlayAPI.sendChannelDataUpdate({
              data: this.handleOverlayMessage(msg, false),
              type: 'channel_msg'
            })
          }
        }
        if (notify_setting.notify_type === ROOM_NOTIFY_SETTING_ENUM['only_at']) { // 如果频道设置仅@，不处理
          return
        }
        // 如果没有房间信息，不进行通知
        if (!room) return
        // 如果是语音频道且现在没有在语音里面，不进行通知
        if (CHANNEL_TYPES.has_audio_types.includes(d.channel_type)) {
          if (this.cur_channel_data.channel_id != d.channel_id) return
        }
      }
      // 如果消息来自组队中心，并且当前在组队页面，不提示
      if (d.source === 'team_center' && this.$route.name === 'team-center') return
      let msg = this.formatNewIMMsg(d, data)
      if (msg.receive_type === IM_RECEIVE_TYPE.private) { // 私聊
        this.addNotice(msg)
        this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
        if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
          let mynotification = new Notification(msg.nickname,{
            body: '收到一条新消息', // 浏览器通知不支持富文本，因此写死文案
            icon: msg.avatar
          });
          mynotification.onclick = function() {
            window.focus();
          }
        }
        if (process.env.IS_CLIENT) {
          window.electronAPI.setTrayMessage(this.handleTrayMessage(msg, 'private'))
        }
      } else if (msg.receive_type === IM_RECEIVE_TYPE.chat_group) {
        let notify_setting = this.all_chat_group_notify_settings[msg.chat_group_id]
        if(notify_setting === ROOM_NOTIFY_SETTING_ENUM.none) {
          return
        }

        const isAt = calcIsGroupAtMe(msg)
        const isUniversal = msg.msg_type === IM_MSG_TYPE.chatGroupUniversal

        if(notify_setting === ROOM_NOTIFY_SETTING_ENUM.only_at && !isAt && !isUniversal) {
          return
        }
        this.addNotice(msg)
        this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
        if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
          let mynotification = new Notification(msg.nickname,{
            body: isAt ? msg.nickname + '@了你' : '收到一条群聊新消息', // 浏览器通知不支持富文本，因此写死文案
            icon: msg.chat_group_avatar
          });
          mynotification.onclick = async () => {
            window.focus();
            this.$router.push({ name: 'friends' })
            EventBus.$emit('Show_Chat_Group_IM', msg.chat_group_id)
          }
        }
        if (process.env.IS_CLIENT) {
          window.electronAPI.setTrayMessage(this.handleTrayMessage(msg, 'chat_group'))
        }
      // 1.53.0版本开放组队大厅入口
      } /** else if (msg.receive_type === IM_RECEIVE_TYPE.global_team) {
        this.addNotice(msg)
        this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
        if (msg.msg_type === IM_MSG_TYPE.globalTeamVoiceInvite) {
          EventBus.$emit('GlobalTeam:handleVoiceInvite', msg);
        }
        if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
          let mynotification = new Notification(msg.nickname,{
            body: `收到一条 ${msg.global_team_info.app_name} 全局组队新消息`,
            icon: msg.global_team_info.app_icon
          });
          mynotification.onclick = () => {
            window.focus();
            if (this.$route.name === 'room' && this.$route.params.room_id == d.global_team_info.room_id) {
              const team_id = d.channel_id
              EventBus.$emit('ChannelSidebar:clickStaticChannel', null, null, CHANNEL_TYPES.global_team)
              this.$nextTick(() => {
                EventBus.$emit('GlobalTeam:handleGetGlobalTeamInfo', team_id)
              })
            } else {
              EventBus.$emit(
                'Join_Room_Or_Channel',
                {
                  room_id: d.global_team_info.room_id,
                },
                '',
                {
                  switch_to_global_team: team_id
                }
              )
            }
          }
        }
      } */ else { // 频道IM
        if (!isCurChannelIm) {
          this.addNotice(msg)
          this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
          if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
            let mynotification = new Notification(msg.nickname,{
              body: this.calcIsAt(msg) ? msg.nickname + '@了你' : '收到一条频道新消息', // 浏览器通知不支持富文本，因此写死文案
              icon: room.avatar || DEFAULT_ROOM_AVATAR
            });
            mynotification.onclick = () => {
              window.focus();
              if (!(this.$route.name === 'room' && this.$route.params.room_id == msg.room_id)) {
                this.$router.push({ name: 'room', params: { room_id: msg.room_id }})
              } else {
                EventBus.$emit("Change_To_Audio_Im");
              }
            }
          }
          if (process.env.IS_CLIENT) {
            msg.room_name = room.room_name
            window.electronAPI.setTrayMessage(this.handleTrayMessage(msg, 'channel'))
          }
        }
      }
    },
    handleTrayMessage (msg, type) {
      const result = {
        id: '',
        avatar: '',
        name: '',
        msg: '',
        count: 1,
        type
      }
      if (type === 'chat_group') { // 群聊消息
        result.id = msg.chat_group_id
        result.avatar = msg.chat_group_avatar
        result.name = msg.chat_group_name
        result.msg = this.getLastMsgText(msg)
      } else if (type === 'private') { // 私聊消息
        result.id = msg.user_id
        result.avatar = msg.avatar
        result.name = msg.nickname
        result.msg = this.getLastMsgText(msg)
      } else if (type === 'channel') { // 频道消息
        result.id = msg.channel_id
        result.channel_id = msg.channel_id
        result.room_id = msg.room_id
        result.avatar = msg.avatar
        result.name = msg.room_name
        result.msg = this.getLastMsgText(msg, 'channel')
      } else if (type === 'official') { // 官方消息
        result.id = 'official_msg'
        result.avatar = 'https://imgheybox.max-c.com/oa/2023/09/01/fc1608e266597a785238a46b6a995a95.png'
        result.name = '系统消息'
        result.msg = msg.content
      } else if (type === 'notify') { // 消息通知
        result.id = 'notify_msg'
        result.avatar = 'https://imgheybox.max-c.com/oa/2023/08/24/d33e5f6446040891ea1176745bd071e2.png'
        result.name = '消息通知'
        result.msg = getMsgDesc(msg)
      } else if (type === 'post') { // 消息通知
        result.id = 'post_msg'
        result.avatar = 'https://imgheybox.max-c.com/oa/2024/04/17/4a9557fd91bbc33267d56c4e79d01638.png'
        result.name = '互动消息'
        result.msg = msg.msg
      }
      return result
    },
    getLastMsgText (msg, type) {
      const msgTypeStr = MESSAGE_CONTENT_COMPONENT(msg)
      let text = msg.msg
      if ([MESSAGE_COMPONENT_TYPE.TEAM_CARD, MESSAGE_COMPONENT_TYPE.TEAM_CARD_V2].includes(msgTypeStr)) {
        text = '[组队卡片]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.TEAM_INVITE) {
        text = '[组队邀约]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.UPLOAD_FILE) {
        text = '[文件]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.TEXT) {
        text = text
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.STICKER) {
        text = '[表情]'
      } else if ([MESSAGE_COMPONENT_TYPE.IMG, MESSAGE_COMPONENT_TYPE.TEXT_AND_IMG].includes(msgTypeStr)) {
        text = '[图片]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.ANCCard){
        text = '[频道公告]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.WELCOME_MSG){ 
        const at_users = msg.at_users || []
        at_users.forEach(v => {
          text = text.replace(new RegExp(`@{id:${v.user_id}}`, 'g'), `@${v.nickname}`)
        })
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.CD_KEY){ 
        text = '[CDKEY已发送]'
      } else if ([MESSAGE_COMPONENT_TYPE.VOTE_ANC, MESSAGE_COMPONENT_TYPE.VOTE].includes(msgTypeStr)) { 
        text = '[投票]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.CUSTOM_CARD) { 
        text = '[卡片消息]'
      } else if ([MESSAGE_COMPONENT_TYPE.POST, MESSAGE_COMPONENT_TYPE.UNKNOWN_POST].includes(msgTypeStr)) { 
        text = '[帖子详情]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.POST_COMMENT) { 
        text = '[评论详情]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.FIGHT) { 
        text = '[开黑名片]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.MINI_PROGRAM) { 
        text = '[小程序]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.MINI_PRO_DETAIL) { 
        if(msg.msg) {
          let msg_content = JSON.parse(msg.msg)
          text = `[${this.getMiniproCardName(msg_content.mini_pro_id)}卡片]`
        }
        else text = `[存档卡片]`
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.SCREEN_SHARE_GIFT) {
        text = '[好友赠礼]'
      } else if (msgTypeStr === MESSAGE_COMPONENT_TYPE.FEEDBACK_CARD) { 
        text = '[反馈消息]'
      } else if (
        [MESSAGE_COMPONENT_TYPE.TOOL_CARD, MESSAGE_COMPONENT_TYPE.INFO_CARD, MESSAGE_COMPONENT_TYPE.COMMENT_CARD, MESSAGE_COMPONENT_TYPE.HEYBOX_GAME_CARD].includes(msgTypeStr)
      ) {
        text = msg.msg
      } else { 
        text = '不支持的消息类型'
      }
      if (type === 'channel') {
        const letters = Array.from(msg.channel_name || '');
        let fristChar = letters[0] ? letters[0].toUpperCase() : ''
        text = `[${fristChar}]${msg.nickname}:${text}`
      }
      text = text.replace(/\[custom(.*?)_(.*?)\]/g, '[表情]');
      return text
    },
    getMiniproCardName(mini_pro_id) {
      switch(mini_pro_id) {
        case 'face_shape':
          return '捏脸'
        default: 
          return '存档'
      }
    },
    handleOverlayMessage (msg, is_screen_share = false) {
      const user_base_info = msg.user_info?.user_base_info || {}
      const result = {
        im_seq: msg.im_seq,
        avatar: user_base_info.avatar || msg.avatar,
        name: calcUserName(user_base_info),
        msg: this.getLastMsgText(msg),
        in_audio: this.cur_channel_data.members?.some(v => v.user_id == msg.user_id),
        user_id: user_base_info.user_id || msg.user_id,
      }
      if (result.msg === '[表情]' && is_screen_share) {
        result.sticker = msg.img
      }
      return result
    },
    handleAtIM(data) {
      if (this.preventNotify) return
      let d = data.data
      // 自己发送的不通知
      if (d.user_id == this.user_info.user_id) return
      // 如果正在展示的频道不进行通知
      if (d.receive_type !== IM_RECEIVE_TYPE.private 
        && d.channel_id == this.channelIMId
      ) return
      // 如果是资源频道不进行通知
      if (d.is_resource_chan) {
        return
      }
      // 如果是语音频道且现在没有在语音里面，不进行通知
      // if (CHANNEL_TYPES.has_audio_types.includes(d.channel_type)) {
      //   if (this.cur_channel_data.channel_id != d.channel_id) return
      // }
      if (d.receive_type !== IM_RECEIVE_TYPE.private) { // 频道消息需要查看通知设置
        let notify_setting = this.$unread.getNotifySetting({
          room_id: d.room_id,
          channel_id: d.channel_id
        })
        if (notify_setting.is_dnds) { // 消息免打扰时直接返回
          return
        }
        if (notify_setting.notify_type !== ROOM_NOTIFY_SETTING_ENUM['only_at']) { // 如果频道通知设置不行仅艾特，不进行处理艾特消息
          // 只有仅艾特才处理5002的艾特消息，其他情况通过5的消息处理
          return
        }
      }
      
      let msg = JSON.parse(JSON.stringify(d))
      msg.key = data.sequence
      let room = this.room_list.find(v => v.room_id == msg.room_id);
      if (!room) return
      msg.card_type = NOTICE_CARD_TYPE['channel_im']
      msg.msg_type = IM_MSG_TYPE['AtOrChannel'] 
      msg.avatar = room.room_avatar || 'default_room_avatar'
      msg.avatarType = 'rectangle'
      msg.title = calcUserName(msg) + `(${msg.channel_name}，${room.room_name})`
      msg.msg = '@了你'
      this.addNotice(msg)
      this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
      if (process.env.IS_CLIENT) {
        msg.room_name = room.room_name
        window.electronAPI.setTrayMessage(this.handleTrayMessage(msg, 'channel'))
      }
      if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
        let mynotification = new Notification(msg.nickname,{
          body: msg.nickname + '@了你', // 浏览器通知不支持富文本，因此写死文案
          icon: room.avatar || DEFAULT_ROOM_AVATAR
        });
        mynotification.onclick = () => {
          window.focus();
          if (!(this.$route.name === 'room' && this.$route.params.room_id == msg.room_id)) {
            this.$router.push({ name: 'room', params: { room_id: msg.room_id }})
          } else {
            EventBus.$emit("Change_To_Audio_Im");
          }
        }
      }
    },
    handleTeamListUpdate(play_audio = true) {
      if (this.preventNotify) return
      // if (this.$route.name === 'team-center') return
      const msg = {
        card_type: 7,
        nickname: '组队工具',
        msg: '等待的组队已更新',
        key: 'team-info',
        iconfont: 'icon-team'
      }
      if (play_audio) {
        if (this.showQueue.length > 0) {
          this.showQueue = []
        }
        this.tip_sound_control(0) && playAudio(require('_audio/team-message.mp3'), this.tip_sound_volume)
      }
      if (this.$route.name === 'team-center') return
      this.addNotice(msg);
    },
    handleReceiveRoomFirstMsg(data) {
      if (this.preventNotify) return
      let d = data.data
      
      if (d.receive_type !== IM_RECEIVE_TYPE.private) { // 查看通知设置
        let notify_setting = this.$unread.getNotifySetting({
          room_id: d.room_id,
          channel_id: d.channel_id
        })
        if (notify_setting.is_dnds) { // 消息免打扰时直接返回
          return
        }
      }
      
      let msg = JSON.parse(JSON.stringify(d))
      msg.key = data.sequence
      let room = this.room_list.find(v => v.room_id == msg.room_id);
      if (!room) return
      msg.card_type = NOTICE_CARD_TYPE['first_notice']
      msg.avatar = room.room_avatar || 'default_room_avatar'
      msg.avatarType = 'rectangle'

      let room_name_arr = Array.from(room.room_name)
      let room_name = room.room_name
      if (room_name_arr.length > 22) {
        room_name_arr = room_name_arr.slice(0, 21)
        room_name_arr.push('...')
        room_name = room_name_arr.join('')
      }
      msg.title = `允许 ${room_name} 推送消息？`
      // msg.msg = ``
      this.addNotice(msg)
      this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
      // if (process.env.IS_CLIENT) {
      //   msg.room_name = room.room_name
      //   window.electronAPI.setTrayMessage(this.handleTrayMessage(msg, 'channel'))
      // }
    },
    handleRoomNotifyTypeChange(data) {
      if (this.preventNotify) return
      let d = data.data
      if (d.operator_id == this.user_info.user_id) return // 自己修改的不通知
      if (d.receive_type !== IM_RECEIVE_TYPE.private) { // 查看通知设置
        let notify_setting = this.$unread.getNotifySetting({
          room_id: d.room_id,
          channel_id: d.channel_id
        })
        if (notify_setting.is_dnds) { // 消息免打扰时直接返回
          return
        }
        if (notify_setting.notify_type && notify_setting.notify_type === d.notify_type) { // 已经设置过房间通知或者当前房间通知设置与更改设置相同时直接返回
          return
        }
      }
      
      let msg = JSON.parse(JSON.stringify(d))
      msg.key = data.sequence
      let room = this.room_list.find(v => v.room_id == msg.room_id);
      if (!room) return
      if(msg.old_notify_type == msg.notify_type) return
      msg.card_type = NOTICE_CARD_TYPE['notice_change']
      msg.avatar = room.room_avatar || 'default_room_avatar'
      msg.avatarType = 'rectangle'
      msg.title = `${room.room_name}通知方式由 ${NOTICE_TYPE_TEXT[String(msg.old_notify_type)]} 修改为 ${NOTICE_TYPE_TEXT[String(msg.notify_type)]}`
      // msg.msg = ``
      const all_notify_settings = {
        ...this.all_notify_settings
      }
      all_notify_settings[d.room_id].notify_type = msg.notify_type
      this.SET_ALL_NOTIFY_SETTINGS(all_notify_settings)
      
      this.addNotice(msg)
      this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
    },
    handleActivityBoxDrop(data) {
      if (this.preventNotify) return
      let msg = data.data
      msg.card_type = 99
      msg.key = data.sequence
      // btn_text、bg_color
      // msg.title = msg.title
      // msg.desc = msg.desc
      // msg.url = msg.url
      msg.avatar = 'https://imgheybox.max-c.com/oa/2023/05/08/08e774f30b79ee3c9f9a09e0c637d36c.png'
      this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
      this.addNotice(msg)
      if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
        let mynotification = new Notification(msg.nickname,{
          body: msg.msg,
          icon: msg.avatar
        });
        mynotification.onclick = () => {
          window.focus();
        }
      }
    },
    handleTeamInviteDue(data) {
      if (this.preventNotify) return
      let msg = data.data.info 
      msg.notify_type = 7
      msg.key = new Date().getTime()
      msg.avatar = msg.room_avatar
      msg.avatarType = 'rectangle'
      msg.card_type = 0
      this.addNotice(msg)
      if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
        let mynotification = new Notification('开黑邀约',{
          body: msg.remaining > 0 ? `5分钟后将开始${msg.title}，赶紧上号吧！`: `${msg.title}即将开始，赶紧上号吧！`, // 浏览器通知不支持富文本，因此写死文案
          icon: DEFAULT_ROOM_AVATAR
        });
        mynotification.onclick = () => {
          window.focus();
          const target = this.recent_msg_list.find(re => re.user_id == NEW_OFFICIAL_MESSAGE_ID.heychat_sys_notify)
          if (target) {
            if (target.new_msg_count) {
              target.new_msg_count--
              this.SET_RECENT_MSG_LIST(this.recent_msg_list)
              this.SET_RECENT_MSG_COUNT(this.recent_msg_count - 1)
            }
          }
          EventBus.$jump({
            room_id: msg.room_id,
            channel_id: msg.channel_id
          })
        }
      }
    },
    handleOfficialMsg (data) {
      if (this.preventNotify) return
      // 系统消息的弹窗通知
      if (data.data.type == 29) return
      const msg = {
        card_type: NOTICE_CARD_TYPE['private_im'],
        msg: markdownToHtml(data.data.content, false, true),
        key: data.sequence,
        ...OFFICAL_MSG_BASIC,
        ...data.data
      }
      this.addNotice(msg)
      this.tip_sound_control(0) && playAudio(MESSAGE_MP3, this.tip_sound_volume)
      if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
        let mynotification = new Notification(msg.nickname,{
          body: msg.msg,
          icon: msg.avatar
        });
        mynotification.onclick = () => {
          window.focus();
        }
      }
      if (process.env.IS_CLIENT) {
        window.electronAPI.setTrayMessage(this.handleTrayMessage(msg, 'official'))
      }
    },
    handleTeamPush (data) {
      if (this.preventNotify) return
      const msg = {
        card_type: NOTICE_CARD_TYPE['operate'],
        notify_type: NOTIFY_TYPES['team_push'],
        nickname: '组队工具',
        msg: data.data.msg,
        key: data.sequence,
        ...data.data
      }
      this.addNotice(msg)
      this.tip_sound_control(0) && playAudio(require('_audio/team-message.mp3'), this.tip_sound_volume)
      if(this.pageHidden && this.notifyAccess && window.client_env !== 'electron') {
        let mynotification = new Notification(msg.nickname,{
          body: msg.msg,
          icon: msg.avatar
        });
        mynotification.onclick = () => {
          window.focus();
        }
      }
    },
    removeCard(index) {
      if (this.disableTransition) {
        this.disableTransition = false
        this.$nextTick(() => {
          this.showQueue.splice(index, 1)
        })
      } else {
        this.showQueue.splice(index, 1)
      }
      
    },
    addNotice(item) {
      let targetQueue = this.showQueue
      if (this.pageHidden) {
        targetQueue = this.waitQueue
      }
      if (this.mergeNotice(item, targetQueue)) {
        this.updateMessageNotified(item.msg_id)
        return
      }
      targetQueue.push(item)
      // 过滤出需要保留的项
      const itemsToKeep = targetQueue.filter(i => i.disable_auto_destroy);

      // 过滤出需要删除的项
      const itemsToRemove = targetQueue.filter(i => !i.disable_auto_destroy);

      // 如果需要删除的项超过2，删除多余的项
      if (itemsToRemove.length > 2) {
        const excessItems = itemsToRemove.length - 2
        for (let i = 0; i < excessItems; i++) {
          const indexToRemove = targetQueue.findIndex(i => !i.disable_auto_destroy)
          if (indexToRemove !== -1) {
            targetQueue.splice(indexToRemove, 1)
          }
        }
      }

      // 确保保留的项仍在队列中
      itemsToKeep.forEach(i => {
        if (!targetQueue.includes(i)) {
          targetQueue.push(i);
        }
      })
      this.updateMessageNotified(item.msg_id)
    },
    // 合并通知
    // 同一个人或者同一个频道的消息通知，合并显示
    mergeNotice(item, targetQueue) {
      let existItem = null
      let index = -1
      
      if (NOTICE_CARD_TYPE.private_im === item.card_type) {
        index = targetQueue.findIndex(v => v.card_type === NOTICE_CARD_TYPE.private_im && v.user_id == item.user_id)
        if (index > -1) {
          existItem = targetQueue[index]
        }
      } else if (NOTICE_CARD_TYPE.channel_im === item.card_type) {
        index = targetQueue.findIndex(v => v.card_type === NOTICE_CARD_TYPE.channel_im && v.channel_id == item.channel_id)
        if (index > -1) {
          existItem = targetQueue[index]
        }
      }else if (NOTICE_CARD_TYPE.chat_group_im === item.card_type) {
        index = targetQueue.findIndex(v => v.card_type === NOTICE_CARD_TYPE.chat_group_im && v.chat_group_id == item.chat_group_id)
        if (index > -1) {
          existItem = targetQueue[index]
        }
      }
      if (existItem) {
        existItem.msg = item.msg
        existItem.msg_type = item.msg_type
        if (!existItem.msg_count) {
          existItem.msg_count = 1
        }
        existItem.msg_count++
        this.$set(existItem, 'isUpdating', true)
        this.disableTransition = true
        targetQueue.splice(index, 1, existItem)
        const card = this.$refs[`noticeCard${existItem.key}`]
        card && card[0].recoverTimer()
        return true
      }
      this.disableTransition = false
      return false
    },
    pageChange(hide) {
      if (this.pageHidden === hide) return
      if(hide){
        this.pageHidden = true
      } else {
        this.pageHidden = false
        this.showQueue = [...this.showQueue, ...this.waitQueue]
        this.waitQueue = []
      }
    },
    checkWindow() {
      // 窗口没显示 按照页面隐藏处理
      if (!this.windowShow) {
        this.pageChange(true)
      } else if (this.windowShow && this.hasFullwindow) { // 窗口显示了但是有全屏窗口在顶层，也按照页面隐藏处理
        this.pageChange(true)
      } else { // 其余情况认为窗口显示中
        this.pageChange(false)
      }
    },
    async handleInitOfflineTray() {
      if (window.client_env !== 'electron') {
        return
      }
      this.offlineTrayCount++
      console.log('this.offlineTrayCount', this.offlineTrayCount);
      if (this.offlineTrayCount !== 3) {
        return
      }
      const maxTrayMsgs = 6
      const trayMsgs = []
      const recents = this.recent_msg_list.filter(item => item.new_msg_count > 0).slice(0, maxTrayMsgs)
      trayMsgs.push(...recents.map(item => {
        let type = 'private'
        if (item.user_id == NEW_OFFICIAL_MESSAGE_ID.heychat_interaction_msg) {
          type = 'post'
        } else if (item.user_id == NEW_OFFICIAL_MESSAGE_ID.heychat_sys_notify) {
          type = 'official'
        } else if (item.user_id == NEW_OFFICIAL_MESSAGE_ID.heybox_message_notify) {
          type = 'notify'
        }
        const result = {
          id: type !== 'private' ? `${type}_msg` : item.user_id,
          avatar: item.avatar,
          name: item.nickname,
          msg: item.last_msg,
          count: item.new_msg_count,
          type
        }
        return result
      }))
      if (trayMsgs.length === maxTrayMsgs) {
        window.electronAPI.setTrayMessages(trayMsgs)
        return
      }
      const room_data = []
      for (let room_id in this.all_unread_states) {
        if (!this.room_list.find(v => v.room_id == room_id)) {
          continue
        }
        const room = this.all_unread_states[room_id]
        const roomUnread = this.$unread.getUnreadState({room_id})
        
        if (!roomUnread || (roomUnread.redCount === 0)) {
          continue
        }
        let max_channel = ''
        let max_channel_msg_id = ''
        let max_channel_msg_count = 0
        for (let channel_id in room) {
          const channel = room[channel_id]
          if (!channel || (!channel.last_read_message_id && !channel.message_count)) {
            continue
          }
          const channelUnreadState = this.$unread.getUnreadState({
            room_id,
            channel_id,
          })
          if (channelUnreadState.redCount && !channelUnreadState.hideNum) {
            if (max_channel === '') {
              max_channel = channel_id
              max_channel_msg_id = channel.last_read_message_id || ''
              max_channel_msg_count = channel.message_count || 0
            } else {
              if (channel.last_read_message_id && !max_channel_msg_id) {
                max_channel = channel_id
                max_channel_msg_id = channel.last_read_message_id
                continue
              }
              if (max_channel_msg_id) {
                if (channel.last_read_message_id && (BigInt(channel.last_read_message_id) > BigInt(max_channel_msg_id))) {
                  max_channel = channel_id
                  max_channel_msg_id = channel.last_read_message_id
                }
              } else if (max_channel_msg_count) {
                if (channel.message_count && (channel.message_count > max_channel_msg_count)) {
                  max_channel = channel_id
                  max_channel_msg_count = channel.message_count
                }
              }
            }
          }
        }
        if (max_channel) {
          room_data.push({
            room_id,
            channel_id: max_channel,
            message_id: max_channel_msg_id,
            message_count: max_channel_msg_id ? 0 : max_channel_msg_count,
          })
        }
      }
      console.log('room_data', JSON.parse(JSON.stringify(room_data)));
      
      let sortedArray = room_data.sort((a, b) => {
        if (a.message_id && b.message_id) {
          return BigInt(a.message_id) > BigInt(b.message_id) ? -1 : 1
        } else if (a.message_id) {
          return -1
        } else if (b.message_id) {
          return 1
        } else {
          return b.message_count - a.message_count
        }
      });
      console.log('sortedArray', JSON.parse(JSON.stringify(sortedArray)));
      
      const restTrayMsgs = sortedArray.slice(0, maxTrayMsgs - trayMsgs.length)
      const msgsRes = await getChannelLastMsg({}, {
        rooms_channel: restTrayMsgs.map(item => ({
          room_id: item.room_id,
          channel_id: item.channel_id
        }))
      })
      if (msgsRes.data.status === 'ok') {
        const msgs = msgsRes.data.result.channels_latest_one_msg
        for (let room_id in msgs) {
          const room = msgs[room_id]
          for (let channel_id in room) {
            const msg = room[channel_id]
            msg.room_id = room_id
            msg.channel_id = channel_id
            msg.avatar = msg.room_avatar || 'default_room_avatar'
            trayMsgs.push(this.handleTrayMessage(messageDataRestructure(msg), 'channel'))
          }
        }
      }
      console.log('trayMsgs', trayMsgs);
      setTimeout(() => {
        window.electronAPI.setTrayMessages(trayMsgs)
      }, 300)
    },
    ...mapActions(['SET_SETTING_DATA_PARAM']),
    ...mapMutations([
      'SET_ALL_NOTIFY_SETTINGS',
      'SET_RECENT_MSG_LIST',
      'SET_RECENT_MSG_COUNT',
      'SET_AUDIO_IM_NEED_SCROLL_TO_BOTTOM',
    ])
  },
};
</script>
<style lang="scss">
.card-enter-active,
.card-leave-active {
  transition: all .3s cubic-bezier(0,0,0.58,1);
}
.card-enter,
.card-leave-to {
  transform: translateY(100px);
}
.card-leave-active {
  position: absolute;
}
</style>